export function normalizeDagCatalog(payload) {
  if (typeof payload === "string") {
    try { payload = JSON.parse(payload); } catch (_) { payload = {}; }
  }
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) payload = {};
  const models = payload.models || payload;
  const items = Array.isArray(payload.items) ? payload.items : Object.entries(models)
    .filter(([, branches]) => Array.isArray(branches))
    .map(([path, sub_dags]) => ({ path, sub_dags, source: "unknown" }));
  return {
    autodagNames: models,
    autodagItems: items.map((item) => ({
      ...item,
      sub_dags: [...new Set((item.sub_dags || []).map(Number)
        .filter((value) => Number.isInteger(value) && value >= 0))].sort((a, b) => a - b),
    })).filter((item) => item.path && item.sub_dags.length),
    dagScanInfo: payload.scan || null,
  };
}

export function isDagSelectionValid(items, path, subDag) {
  if (subDag === null || subDag === undefined || subDag === "") return false;
  return Boolean(items.find((item) => item.path === path)?.sub_dags.includes(Number(subDag)));
}
